/**
 * Single source of truth for Blue Speed Construction's public contact details.
 *
 * ⚠️ BEFORE LAUNCH: replace `whatsappDigits` / `whatsappDisplay` with the real
 * WhatsApp Business number. The values below are placeholders.
 */

export const COMPANY_NAME = "Blue Speed Construction Pte. Ltd.";
export const COMPANY_ESTABLISHED = "1996";

// Country code + number, digits only (format required by wa.me links).
export const WHATSAPP_DIGITS = "6583818526";
export const WHATSAPP_DISPLAY = "+65 8381 8526";

/**
 * Web3Forms access key for the contact form.
 *
 * Web3Forms keys are designed to sit in client-side code — the key only allows
 * submissions to the mailbox it was created for, so it is not a secret. Set
 * VUE_APP_WEB3FORMS_KEY at build time to point a deployment at another mailbox.
 */
export const WEB3FORMS_ACCESS_KEY =
  process.env.VUE_APP_WEB3FORMS_KEY || "0d364939-392f-406a-8fca-75366afc8457";
  // process.env.VUE_APP_WEB3FORMS_KEY || "5236aab7-0574-4ae2-86e4-9de970754b62";
// 0d364939-392f-406a-8fca-75366afc8457
/**
 * hCaptcha sitekey for the contact form.
 *
 * This is Web3Forms' shared sitekey for free plans — Web3Forms holds the secret
 * and verifies the token server-side, so no hCaptcha account of our own is
 * needed. hCaptcha must still be switched on in the Web3Forms dashboard for the
 * access key above, otherwise the token is accepted without being checked.
 *
 * Paid plans may use their own key: set VUE_APP_HCAPTCHA_SITEKEY at build time.
 * Set it to an empty string to drop the captcha and rely on the honeypot alone.
 */
export const HCAPTCHA_SITEKEY =
  process.env.VUE_APP_HCAPTCHA_SITEKEY ?? "50b2fe65-b00b-4b9e-ad62-3ba471098be2";

export const BCA_REGISTRATIONS = [
  { code: "CW01", title: "General Building" },
  { code: "CR09", title: "Repairs and Redecoration" },
  {
    code: "FM02",
    title: "Housekeeping, Cleansing, Desilting and Conservancy Services",
  },
];

/**
 * Builds a wa.me deep link with a pre-filled message.
 * @param {string} message Plain text; encoded here so callers don't have to.
 */
export function whatsappLink(message = "Hi Blue Speed, I would like to enquire about a project.") {
  return `https://wa.me/${WHATSAPP_DIGITS}?text=${encodeURIComponent(message)}`;
}
